var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 14.1094C13.1625 14.1094 14.1141 13.1625 14.1141 11.9953C14.1141 11.5359 13.9641 11.1094 13.7156 10.7625C13.3312 10.2328 12.7078 9.88123 12.0047 9.88123C11.3016 9.88123 10.6781 10.2281 10.2937 10.7625C10.0453 11.1094 9.89531 11.5359 9.89531 11.9953C9.89062 13.1625 10.8375 14.1094 12 14.1094Z",
    fill: "#E66767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6125 9.41719V7.64531V7.38281H16.35L14.5781 7.3875L14.5875 9.42188L16.6125 9.41719Z",
    fill: "#E66767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2812 12C15.2812 13.8094 13.8094 15.2813 12 15.2813C10.1906 15.2813 8.71875 13.8094 8.71875 12C8.71875 11.5641 8.80781 11.1469 8.9625 10.7672H7.17188V15.6797C7.17188 16.3125 7.6875 16.8281 8.32031 16.8281H15.6797C16.3125 16.8281 16.8281 16.3125 16.8281 15.6797V10.7672H15.0375C15.1969 11.1469 15.2812 11.5641 15.2812 12Z",
    fill: "#E66767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37188 0 0 5.37188 0 12C0 18.6281 5.37188 24 12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0ZM18 10.7672V15.6797C18 16.9594 16.9594 18 15.6797 18H8.32031C7.04063 18 6 16.9594 6 15.6797V10.7672V8.31562C6 7.03594 7.04063 5.99531 8.32031 5.99531H15.6797C16.9594 5.99531 18 7.03594 18 8.31562V10.7672Z",
    fill: "#E66767"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.34baf895863837464350cc09ca1be75e.svg";
export { ForwardRef as ReactComponent };